import Menu, { type MenuProps } from '@mui/material/Menu';
import { styled } from '@mui/material/styles';

const StyledMenu = styled(Menu)<MenuProps>(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export default StyledMenu;
